// extracted by mini-css-extract-plugin
export default {"fields":"CompetenciesFormFields-module__fields__qJRC8"};